<nav class="header-nav">
    <div class="subinner-nav m-fwrap">
        <div class="s_inner-left mw-100 m-hide">
            <span class="subinner-tit" [ngClass]="(isNavExpanded? 'subinner-tit-expanded' : 'subinner-tit-collapsed')">
                {{selectedHeader.label}}</span>
            <span *ngIf="selectedMenuItem" class="subinner-subtit blue-text">{{ selectedMenuItem.label}}</span>
            <span *ngIf="selectedSubMenuItem && selectedSubMenuItem.label" class="pipe pipe-grey">|</span>
            <span *ngIf="selectedSubMenuItem" class="subinner-page">{{ selectedSubMenuItem.label}}</span>
        </div>
        <div class="s_inner_right mw-100 md-flex-start">
        </div>
    </div>
</nav>

<div id="sidenav" class="sidenav"
    [ngClass]="{'sidenav-expaned-mobile': isNavExpanded,'is-collapsed': !isNavExpanded,'is-mobile-expanded':hamburgerMenuFlag, 'is-mobile-collapsed':!hamburgerMenuFlag, 'sidenav-t-60':isStartRoundSectionVisible,'sidenav-t-0': !isStartRoundSectionVisible}">
    <div id="leftSidemenu" class="nav">
        <button class="sidenav__button" aria-label="Expand" (click)="toggleNavExpanded()">
            <span class="sidenav__button-icon">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
            </span>
        </button>
        <nav class="sidenav__nav nav">
            <ul class="nav__list accordion">
                <ng-container *ngFor="let link of _headerLinks">
                    <div *ngIf="link.label =='Contact Us'" class="nav__divider"></div>
                    <li class="nav__item" *ngIf="!headerHasMenuItems(link)" id="{{ link.name + 'Menu' }}"
                        [ngClass]="isHeaderSelected(link)? 'is-active' : ''" (click)="headerSelected(link)">

                        <a class="nav__button" [routerLink]="link.routeUrl" [queryParams]="link.queryParams">
                            <span class="nav__icon">
                                <i [ngClass]="link.iconClass" aria-hidden="true"></i>
                            </span>
                            <span class="nav__label">{{link.label}}</span>
                        </a>
                    </li>


                    <li class="nav__item" *ngIf="headerHasMenuItems(link)" id="{{ link.name + 'sideNavGroupSubmenu' }}"
                        [ngClass]="isHeaderSelected(link)? 'is-active' : ''" (click)="showNavExpanded()">
                        <button (click)="headerSelected(link)" class="nav__button section"
                            [ngClass]="isHeaderSelected(link) && isHeaderExpanded? 'is-active' : ''">
                            <span class="nav__icon">
                                <i [ngClass]="link.iconClass" aria-hidden="true"></i>
                            </span>
                            <span class="nav__label">{{link.label}}</span>
                        </button>
                        <div class="panel"
                            [ngStyle]="{'display': (isHeaderSelected(link) && isHeaderExpanded ? 'block' : 'none')}"
                            *ngIf="isHeaderSelected(link) && isHeaderExpanded">
                            <ng-container *ngFor="let menu of link.menuItems">
                                <span id="{{ 'subMenu' + menu.name }}">
                                    <div *ngIf="menu.route?.length > 0">
                                        <p>
                                            <a class="menu-link" (click)="menuItemSelected(menu)" [routerLink]="menu.route"
                                                [queryParams]="menu.queryParams"
                                                [ngStyle]="{'font-weight': (isMenuItemSelected(menu) ? 'bold' : 'normal')}">
                                                {{menu.label }}
                                            </a>
                                        </p>
                                   </div>
                                   <div *ngIf="menu.route?.length == 0" [ngStyle]="{'font-weight': (isMenuItemSelected(menu) ? 'bold' : 'normal')}">
                                       <p class="disabled-link">{{menu.label }}</p>
                                    </div>
                                    <ng-container *ngFor="let subMenu of menu.subMenuItems">
                                        <span id="{{ 'childSubMenu' + subMenu.name }}">
                                            <p>&nbsp;
                                                <a (click)="subMenuItemSelected(subMenu)" class="menu-link"
                                                    [routerLink]="subMenu.route"
                                                    [ngStyle]="{'font-weight': (isSubMenuItemSelected(subMenu) ? 'bold' : 'normal')}"
                                                    [queryParams]="subMenu.queryParams">
                                                    {{subMenu.label }}
                                                </a>
                                            </p>
                                        </span>
                                    </ng-container>
                                </span>
                            </ng-container>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </nav>
    </div>
</div>
